<template>
  <div class="md-layout md-alignment-top-center">
    <div class="md-layout-item md-size-25">
      <md-button class="md-icon-button" style="width: 100%; height: 100%" @click='showAvatarDialog = true'>
        <md-avatar class="md-large" alt="Avatar">
          <md-icon v-if="newPhotoURL === '' || newPhotoURL === null">account_circle</md-icon>
          <img v-else :src="newPhotoURL">
        </md-avatar>
      </md-button>
    </div>
    <div v-if="currentUser.providerId === provider.email" class="md-layout-item md-size-95">
      <md-field>
        <label>E-mail</label>
        <md-input v-model="newEmail"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-95">
      <md-field :class="{ 'md-invalid': isNewNameInUse || nameLessThan3Chars }">
        <label>Name</label>
        <md-input v-model="newName" @change="nameOnChange"></md-input>
        <span class="md-error" v-if="isNewNameInUse">Name is already in use</span>
        <span class="md-error" v-if="nameLessThan3Chars">Name has to be at least 3 characters in length</span>
      </md-field>
    </div>
    <div v-if="currentUser.providerId === provider.email" class="md-layout-item md-size-95">
      <md-field>
        <label>Password</label>
        <md-input v-model="newPassword" type="password"></md-input>
      </md-field>
    </div>
    <div v-if="currentUser.providerId === provider.email" class="md-layout-item md-size-95">
      <md-field :class="{ hidden: !passwordChanged, 'md-invalid': !passwordsMatch }">
        <label>Repeat Password</label>
        <md-input v-model="repeatPassword" type="password"></md-input>
        <span class="md-error">Passwords do not match</span>
      </md-field>
    </div>
    <div class="md-layout-item md-size-100">
      <div class="md-layout md-alignment-bottom-center">
        <div class="md-layout-item md-size-30">
          <md-button class="md-dense md-raised md-accent" v-if="profileChanged" @click="$emit('cancel')">Cancel</md-button>
          <md-button class="md-dense md-raised md-accent" v-if="!profileChanged" @click="$emit('cancel')">Close</md-button>
        </div>
        <div class="md-layout-item md-size-40">
        </div>
        <div class="md-layout-item md-size-30">
          <md-button class="md-dense md-raised md-accent" v-if="readyToSave" @click="saveChanges()">Save</md-button>
        </div>
      </div>
    </div>
    <md-dialog class="avatarDialog" :md-active.sync="showAvatarDialog" id="avatarDialog">
      <md-dialog-content>
        <div class="text-center">
          <!--img v-if="photoURL === ''" :src="photoURL" -->
          <avatar-cropper
            :upload-handler="uploadAvatar"
            trigger="#pick-avatar"
            :labels="{ cancel: 'CANCEL', submit: 'SUBMIT' }" />
          <div class="md-layout md-alignment-bottom-center">
            <div class="md-layout-item md-size-100" style="height: 300px">
            </div>
            <div class="md-layout-item md-size-40">
              <md-button class="md-dense md-raised md-accent" @click="showAvatarDialog=false">Cancel</md-button>
            </div>
            <div class="md-layout-item md-size-20">
            </div>
            <div class="md-layout-item md-size-40">
              <md-button id="pick-avatar" class="md-dense md-raised md-accent">Load Image</md-button>
            </div>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
    <md-dialog class="reAuthenticateDialog" :md-active.sync="showReAuthenticateDialog" id="reAuthenticateDialog">
      <md-dialog-content>
          <re-authenticate
            @success='successfulReAuthenticate'
            @cancel='showReAuthenticateDialog = false' />
      </md-dialog-content>
    </md-dialog>
  </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { signInProvider, isInUse, caseFoldNormalize } from '../constants'
import AvatarCropper from 'vue-avatar-cropper'
import reAuthenticate from './Reauthenticate'

export default {
  name: 'UserProfile',
  components: {
    AvatarCropper,
    reAuthenticate
  },
  data: function () {
    return {
      name: '',
      newName: '',
      email: '',
      newEmail: '',
      photoURL: '',
      newPhotoURL: '',
      password: '',
      newPassword: '',
      repeatPassword: '',
      provider: signInProvider,
      showAvatarDialog: false,
      showReAuthenticateDialog: false,
      newNameInUse: isInUse.unchecked,
      userIsNew: false,
      lastCheckedName: ''
    }
  },
  created: function () {
    this.userIsNew = this.currentUser.new
    this.name = this.currentUser.displayName
    this.newName = this.name
    if (this.userIsNew) {
      this.name = ''
      if (!this.nameLessThan3Chars) {
        this.nameOnChange()
      }
    }
    this.photoURL = this.currentUser.photoURL
    this.newPhotoURL = this.photoURL
    this.email = this.currentUser.email
    this.newEmail = this.email
  },
  computed: {
    ...mapState(['currentUser']),
    readyToSave: function () {
      return (this.nameChanged || this.emailChanged || this.photoChanged || this.passwordChanged) && ((this.passwordChanged && this.passwordsMatch) || !this.passwordChanged) && !this.isNewNameInUse && !this.nameLessThan3Chars
    },
    profileChanged: function () {
      return (this.passwordChanged || this.nameChanged || this.emailChanged || this.photoChanged)
    },
    passwordChanged: function () {
      return this.password !== this.newPassword
    },
    passwordsMatch: function () {
      return this.newPassword === this.repeatPassword
    },
    nameChanged: function () {
      return this.name !== this.newName
    },
    emailChanged: function () {
      return this.email !== this.newEmail
    },
    photoChanged: function () {
      return this.photoURL !== this.newPhotoURL
    },
    nameLessThan3Chars: function () {
      return this.newName.trim().length < 3
    },
    isNewNameInUse: function () {
      if (this.newNameInUse === isInUse.yes && this.lastCheckedName === caseFoldNormalize(this.newName)) {
        return true
      } else return false
    }
  },
  methods: {
    ...mapActions(['uploadNewAvatar', 'isNameInUse', 'updateUserName', 'updateProfilePhoto', 'updateEmail', 'updatePassword', 'refreshUser', 'displayError']),
    uploadAvatar (cropper) {
      let outputOptions = {width: 512, height: 512}
      let outputMime = 'image/jpeg'
      let outputQuality = 0.9
      cropper.getCroppedCanvas(outputOptions).toBlob(
        blob => {
          this.uploadNewAvatar(blob).then(downloadURL => {
            this.newPhotoURL = downloadURL
            this.showAvatarDialog = false
          }).catch(err => {
            console.log(err.message)
            this.showAvatarDialog = false
          })
        },
        outputMime,
        outputQuality
      )
    },
    nameOnChange () {
      return new Promise((resolve, reject) => {
        let nameToCheck = this.newName
        if (this.nameChanged && !this.nameLessThan3Chars && caseFoldNormalize(nameToCheck) !== this.lastCheckedName) {
          this.isNameInUse(nameToCheck).then(isUsed => {
            this.newNameInUse = isUsed
            this.lastCheckedName = caseFoldNormalize(nameToCheck)
            resolve()
          }).catch(err => {
            console.log(err.message)
            reject(new Error(err.message))
          })
        }
      })
    },
    async saveChanges () {
      // TODO: If user is changing email or password, need to reauthenticate.
      // Try repurposing Login.vue in a dialog for reauthenticating.
      if (this.emailChanged || this.passwordChanged) {
        this.showReAuthenticateDialog = true
      } else {
        if (this.nameChanged && !this.nameLessThan3Chars && !this.isNewNameInUse) {
          let changedName = this.newName
          await this.updateUserName(changedName).then(() => {
            this.name = changedName
          }).catch(err => {
            this.displayError('There was an error saving your UserName.  Please try again.' + err.message)
          })
        }
        if (this.photoChanged) {
          let changedPhotoURL = this.newPhotoURL
          await this.updateProfilePhoto(changedPhotoURL).then(() => {
            this.photoURL = changedPhotoURL
          }).catch(err => {
            this.displayError('There was an error saving your photo.  Please try again.' + err.message)
          })
        }
        await this.refreshUser().then(() => {
          this.userIsNew = this.currentUser.new
          this.name = this.currentUser.displayName
          this.newName = this.name
          if (this.userIsNew) {
            this.name = ''
            if (!this.nameLessThan3Chars) {
              this.nameOnChange()
            }
          }
          this.photoURL = this.currentUser.photoURL
          this.newPhotoURL = this.photoURL
          this.email = this.currentUser.email
          this.newEmail = this.email
        })
      }
    },
    async successfulReAuthenticate () {
      this.showReAuthenticateDialog = false
      if (this.emailChanged) {
        let changedEmail = this.newEmail
        await this.updateEmail(changedEmail).then(() => {
          this.email = changedEmail
        }).catch(err => {
          this.displayError('There was an error updating your email.  Please try again.' + err.message)
        })
      }
      if (this.passwordChanged) {
        let changedPassword = this.newPassword
        await this.updatePassword(changedPassword).then(() => {
          this.password = ''
          this.newPassword = ''
          this.repeatPassword = ''
        }).catch(err => {
          this.displayError('There was an error updating your password.  Please try again.' + err.message)
        })
      }
      if (this.nameChanged && !this.nameLessThan3Chars && !this.isNewNameInUse) {
        let changedName = this.newName
        await this.updateUserName(changedName).then(() => {
          this.name = changedName
        }).catch(err => {
          this.displayError('There was an error saving your UserName.  Please try again.' + err.message)
        })
      }
      if (this.photoChanged) {
        let changedPhotoURL = this.newPhotoURL
        await this.updateProfilePhoto(changedPhotoURL).then(() => {
          this.photoURL = changedPhotoURL
        }).catch(err => {
          this.displayError('There was an error saving your photo.  Please try again.' + err.message)
        })
      }
      await this.refreshUser().then(() => {
        this.userIsNew = this.currentUser.new
        this.name = this.currentUser.displayName
        this.newName = this.name
        if (this.userIsNew) {
          this.name = ''
          if (!this.nameLessThan3Chars) {
            this.nameOnChange()
          }
        }
        this.photoURL = this.currentUser.photoURL
        this.newPhotoURL = this.photoURL
        this.email = this.currentUser.email
        this.newEmail = this.email
      })
    }
  }
}
</script>

<style>
.hidden {
  visibility: hidden;
}
.fullWidth {
  width: 100%;
}
.avatarDialog {
  width: 250px;
  height: 350px;
}
.avatarDialog .md-dialog-content {
  padding: 0 0 0;
}
</style>
